import { Pipe, PipeTransform } from '@angular/core';
import { Rank } from '../models/rank';

@Pipe({
  name: 'rankCatToRank'
})
export class RankCatToRankPipe implements PipeTransform {

  transform(ranks: Rank[], rankCatIdFilter?: number): any[] {
    if (!ranks || !rankCatIdFilter) {
      return ranks;
    }
    return ranks.filter(a => a.rankCategoryId === rankCatIdFilter);
  }

}
